export default __webpack_public_path__ + "static/media/logo_italo.aeabedc1.svg";